export const ReleaseVersion: any = {
  version: '1.0.x',
  releaseDate: 'NA'
};
